module.exports = __webpack_public_path__ + "media/images/core_values/commitment-b7d30c2d155a5e6571bf847be013a4b8.png";